import React, { useEffect, useCallback } from "react"; // useState will be used for future pallet ID functionality
import { FullscreenModal } from "./components/FullscreenModal";
import { StepHeader } from "./components/StepHeader";
import { TakebackQueueIcon } from "./components/TakebackQueueIcon";
import { BottomNav } from "./components/BottomNav";
import {
  WarehouseButtonsFooter,
  WarehouseButton,
} from "./components/WarehouseButtonsFooter";
import fullXStorageIcon from "./images/full-x-storage-icon.png"; // For future use
import dropoffXStorageIcon from "./images/dropoff-x-storage-icon.png";
import mailInStorageIcon from "./images/mail-in-storage-icon.png";
import { useSteps } from "./useSteps";
import { useWarehouseContext } from "./WarehouseProvider";

export const StorageRouting = ({ onInventoryClick, onAlertsClick }) => {
  // const [palletId, setPalletId] = useState(""); // For future pallet ID functionality
  const { dropStoreMode, nextCheckInStep } = useSteps();
  const { currentTakeback } = useWarehouseContext();

  const handleComplete = useCallback(() => {
    // if (palletId.trim()) {
    //   // Move to the next step in the check-in process
    //   nextCheckInStep();
    // }
    // For now, complete check-in immediately when button is pressed
    nextCheckInStep();
  }, [nextCheckInStep]);

  // Handle Enter key to trigger Ok, Done
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleComplete();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [handleComplete]);

  const getStorageConfig = () => {
    // Get returnTypeOffered from takeback data
    const data =
      typeof currentTakeback?.data === "object"
        ? currentTakeback?.data
        : JSON.parse(currentTakeback?.data || "{}");
    const returnTypeOffered = data.returnTypeOffered;

    // Determine storage type based on dropStoreMode
    if (!dropStoreMode) {
      // Mail-In Storage - if drop off is disabled
      return {
        icon: mailInStorageIcon,
        title: "Place on Transport Pallet B",
        subtitle:
          "This trade-in should be placed into temporary storage for future processing.",
      };
    } else if (data?.returnMethod.includes("in_store")) {
      // Drop-off X Storage - if drop off is enabled
      // Determine the location based on returnTypeOffered
      let location = "Store";
      switch (returnTypeOffered) {
        case "CO":
          location = "Colorado Store";
          break;
        case "NJ":
          location = "New Jersey Store";
          break;
        case "PA":
          location = "Pennsylvania Store";
          break;
        case "AR":
          location = "Arkansas Store";
          break;
        default:
          location = "Store";
      }

      return {
        icon: dropoffXStorageIcon,
        title: `Place on Transport Pallet C for ${location}`,
        subtitle:
          "This trade-in should be placed into temporary storage for future processing.",
      };
    } else {
      // Full X Storage
      return {
        icon: fullXStorageIcon,
        title: "Place on Transport Pallet A",
        subtitle: "This trade-in is ready for long term storage",
      };
    }
  };

  const config = getStorageConfig();

  if (!config) return null;

  return (
    <FullscreenModal>
      <div className="flex flex-col h-full">
        <StepHeader
          showModal={false}
          showLogIssueIcon={false}
          rightSlot={<TakebackQueueIcon />}
          isLoading={false}
        />

        <div className="flex-1 flex flex-col pt-[120px]">
          <div className="flex flex-col items-center w-full max-w-[672px] mx-auto">
            <div className="flex flex-col items-center">
              <img
                src={config.icon}
                alt="Storage Icon"
                className="w-[168px] h-[168px] mb-6"
              />
              <div className="flex flex-col items-center gap-[6px] mb-16">
                <h1 className="text-[29px] font-bold text-white leading-[37px] tracking-[-0.01em] text-center font-manrope">
                  {config.title}
                </h1>
                <p className="text-lg font-normal text-[#C6CCE8] leading-[23px] text-center font-manrope">
                  {config.subtitle}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-[115px] left-0 right-0">
          <WarehouseButtonsFooter>
            {/* Pallet ID input - functionality not ready yet */}
            {/* <div className="flex-1">
              <input
                className="rounded-lg px-6 py-6 border border-[#595F77] focus:outline-none focus:ring-0 w-full bg-[#030711] text-white placeholder-[#595F77] text-lg h-[80px] font-space-mono"
                type="text"
                value={palletId}
                placeholder="Enter pallet ID"
                onChange={(e) => setPalletId(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && palletId.trim()) {
                    e.preventDefault();
                    handleComplete();
                  }
                }}
              />
            </div> */}

            <WarehouseButton variant="primary" onClick={handleComplete}>
              Ok, Done
            </WarehouseButton>
          </WarehouseButtonsFooter>
        </div>

        <BottomNav
          activeTab="processing"
          onInventoryClick={onInventoryClick}
          onAlertsClick={onAlertsClick}
        />
      </div>
    </FullscreenModal>
  );
};
